import { featureItems } from '@/mocks/homeData';

export default function Features() {
  return (
    <section id="features" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">观影优势</h2>
          <p className="text-sm text-foreground-500">为什么选择春夜影院</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {featureItems.map((item) => (
            <div key={item.id} className="text-center bg-background-100 rounded-lg p-5 md:p-6">
              <div className="w-12 h-12 mx-auto mb-4 rounded-lg bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}